import React, { useEffect } from 'react';
import { BoxSelection, BoxSelectionBoxSize, Text, TextButton } from 'wix-ui-tpa/cssVars';
import { classes, st } from './slots.st.css';
import { useConfig } from '../../../../contexts/config-context';
import { bulkSlotsSize } from '../../appointmentState';
import { Loader } from '../../loader';
import { getSlotKey, formatTimeRange, getFormattedDateLabel, getSlotByKey } from './utils';
import { useTranslation } from '../../../../contexts/translation-context';
import { Notification } from '../../notification';
export const TimeSlots = _ref => {
  let {
    appointmentState,
    isReloadingSlots,
    appointmentFieldProps,
    setAppointmentState
  } = _ref;
  const selectedSlot = appointmentFieldProps.value;
  const {
    locale
  } = useConfig();
  const {
    t
  } = useTranslation();
  const [selectedId, setSelectedId] = React.useState(getSlotKey(selectedSlot));
  const {
    isMobile
  } = useConfig();
  const {
    availabilitySlots,
    timezone = ''
  } = appointmentState || {};
  useEffect(() => {
    setSelectedId(getSlotKey(selectedSlot));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSlot]);
  const onSlotSelected = id => {
    if (appointmentFieldProps != null && appointmentFieldProps.onChange && availabilitySlots) {
      var _newSelectedSlot$slot, _newSelectedSlot$slot2;
      const newSelectedSlot = getSlotByKey(id, availabilitySlots);
      if (newSelectedSlot != null && (_newSelectedSlot$slot = newSelectedSlot.slot) != null && _newSelectedSlot$slot.endDate && newSelectedSlot != null && (_newSelectedSlot$slot2 = newSelectedSlot.slot) != null && _newSelectedSlot$slot2.startDate) {
        appointmentFieldProps == null || appointmentFieldProps.onChange({
          startDate: newSelectedSlot.slot.startDate,
          endDate: newSelectedSlot.slot.endDate,
          timeZone: timezone
        });
      }
    }
  };
  const isMoreSlotsToDisplay = () => {
    var _appointmentState$ava, _appointmentState$ava2;
    const bulkSize = appointmentState.currentSlotBulkSize || bulkSlotsSize;
    return !!(appointmentState != null && (_appointmentState$ava = appointmentState.availabilitySlots) != null && _appointmentState$ava.length && bulkSize < (appointmentState == null || (_appointmentState$ava2 = appointmentState.availabilitySlots) == null ? void 0 : _appointmentState$ava2.length));
  };
  const onShowMoreClicked = () => {
    if (isMoreSlotsToDisplay()) {
      const bulkSize = appointmentState.currentSlotBulkSize || bulkSlotsSize;
      setAppointmentState({
        ...appointmentState,
        currentSlotBulkSize: bulkSize + bulkSlotsSize
      });
    }
  };
  const renderSlots = () => {
    if (isReloadingSlots) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    if (!(availabilitySlots != null && availabilitySlots.length)) {
      return /*#__PURE__*/React.createElement(Notification, {
        message: t('form.appointment.slots-not-found.text')
      });
    }
    return availabilitySlots.slice(0, appointmentState.currentSlotBulkSize).map(slot => {
      var _slot$slot, _slot$slot2;
      if (!slot.slot || !slot.slot.startDate || !slot.slot.endDate) {
        return null;
      }
      const {
        startDate,
        endDate
      } = slot.slot;
      const timeRange = formatTimeRange({
        startDate,
        endDate,
        locale,
        timezone
      });
      const key = getSlotKey({
        startDate: slot == null || (_slot$slot = slot.slot) == null ? void 0 : _slot$slot.startDate,
        endDate: slot == null || (_slot$slot2 = slot.slot) == null ? void 0 : _slot$slot2.endDate
      });
      return /*#__PURE__*/React.createElement(BoxSelection.Option, {
        key: key,
        id: key,
        className: classes.boxSelectionOption,
        checked: selectedId === key
      }, /*#__PURE__*/React.createElement(Text, {
        className: classes.timeRange
      }, timeRange));
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root, {
      isMobile
    })
  }, /*#__PURE__*/React.createElement(BoxSelection, {
    size: BoxSelectionBoxSize.small,
    className: classes.boxSelection,
    name: "hour-selection",
    label: getFormattedDateLabel({
      selectedDate: appointmentState.selectedDate,
      locale,
      timezone
    }),
    onChange: _ref2 => {
      let {
        id
      } = _ref2;
      return onSlotSelected(id);
    }
  }, renderSlots()), !!isMoreSlotsToDisplay() && !isReloadingSlots && /*#__PURE__*/React.createElement(TextButton, {
    className: classes.textButton,
    onClick: () => onShowMoreClicked()
  }, t('form.appointment.show-more-slots.text')));
};
//# sourceMappingURL=index.js.map